// import positionFormLabels from './../formLabels/formLabels';

export default class twzSelect {
    constructor(selectfields) {

        if( selectfields.length ) {
            selectfields = this.getVisibleFields(Array.from(selectfields));
            
            if(selectfields.length > 0) {
                this.init(selectfields);
            }
        }
        
    }

    init = (selectfields) => {
        
        selectfields.forEach( select => this.setFakeSelectPlaceholder(select, this.getSelected(select) ) );
        
        document.querySelectorAll('.twz-select').forEach( select => {
            
            let selectOptions = document.querySelectorAll(`select[id="${select.dataset.originalId}"] option`);
            this.setFakeSelectDropdown(select, selectOptions); 
            select.addEventListener('click', e => e.target.classList[e.target.classList.contains('twz-select--is-open')?'remove':'add']('twz-select--is-open'))
        });

        window.addEventListener('click', (e) =>  {
            if(e.target.classList.contains('twz-select') == false && e.target.classList.contains('twz-select__selected') == false) {
                document.querySelectorAll('.twz-select').forEach(sel => sel.classList.remove('twz-select--is-open'));
            }
        })

    }

    getSelected = (select) => {
        let selected = select.querySelectorAll('option:checked')
        ? select.querySelector('option:checked')
        : select.querySelector('option');

        selected.dataset.twzSelected = true;

        return selected;
    }

    // Check for a display none style to see if the field isn't hidden
    getVisibleFields = (fields) => fields.filter(field => window.getComputedStyle(field, null).display != 'none');

    setActive = (option) => {

        option.parentNode.querySelectorAll('.twz-select__option-wrap').forEach(option => option.classList.remove('active'));
        option.classList.add('active');
        
        const parentContainer = option.closest('.twz-select__dropdown').parentNode.parentElement;
        const selectField = parentContainer.querySelector('.twz-select');

        parentContainer.querySelector('.twz-select__selected').innerText = option.querySelector('span').innerText;
        selectField.dataset.selectedValue = option.dataset.inputValue;
        parentContainer.parentNode.querySelector('select').value = option.dataset.inputValue;
        parentContainer.querySelectorAll(`select option`).forEach(option => option.dataset.twzSelected = false);
        parentContainer.querySelector(`select option[value="${option.dataset.inputValue}"]`).dataset.twzSelected = true;
    }

    setFakeSelectPlaceholder = (select, selected = this.getSelected(select)) => {

        let selectWrapper = document.createElement('div');
        selectWrapper.classList.add('twz-select');

        const sfPlaceholderValue = document.createElement('span');
        sfPlaceholderValue.classList.add('twz-select__selected');
        selectWrapper.dataset.selectedValue = selected.value;
        sfPlaceholderValue.innerText = selected.innerText;

        selectWrapper.dataset.originalId = select.id;
        selectWrapper.appendChild(sfPlaceholderValue);
        selectWrapper.style.width = `${select.parentNode.parentNode.clientWidth}px - ${select.parentNode.parentNode.style.paddingRight}`;
        
        select.parentNode.appendChild(selectWrapper);
        select.classList.add('twz-select__hiddenselect')
    }
    

    setFakeSelectDropdown = (select, options) => {        
        const sfWrapper = document.createElement('div');
        sfWrapper.classList.add('twz-select__dropdown');

        options.forEach(of => {

            const sfOption = document.createElement('div');
            sfOption.classList.add('twz-select__option-wrap');
            
            const sfOptionVal = document.createElement('span');
            sfOptionVal.classList.add('twz-select__option');

            sfOption.appendChild(sfOptionVal);

            sfOption.dataset.inputValue = of.value;
            sfOptionVal.innerText = of.innerText;

            sfOption.addEventListener('click', (e) => {
                this.setActive(e.target);
                select.classList.remove('twz-select--is-open')
            })

            sfWrapper.appendChild(sfOption);
        });

        select.insertBefore(sfWrapper, select.nextSibling);
    }
}